import React from 'react';
import Image from 'next/image';
import styles from './Checkbox.module.scss';
import assetLoader from "@utils/internalImageLoder";

interface CheckboxProps {
  label: string;
  checked: boolean;
  onChange: () => void;
  className?: string;
}

const Checkbox: React.FC<CheckboxProps> = ({ label, checked, onChange, className }) => {
  return (
    <label className={`${styles.container} ${className}`}>
      <div className={styles.checkboxWrapper}>
        <input
          type="checkbox"
          checked={checked}
          onChange={onChange}
          className={styles.input}
        />
        <div className={`${styles.checkbox} ${checked ? styles.checked : ''}`}>
          {checked && (
            <Image
              src={`${assetLoader()}/icons/tick-light.svg`}
              alt="Checked"
              width={11}
              height={8}
            />
          )}
        </div>
      </div>
      <span className={styles.label}>{label}</span>
    </label>
  );
};

export default Checkbox; 